import React from "react";

const logos = [
  { name: "Jitter", imgSrc: "images/jitter.png" },
  { name: "Krisp", imgSrc: "images/krisp.png" },
  { name: "Feedly", imgSrc: "images/feedly.png" },
  { name: "Draftbit", imgSrc: "images/draft.png" },
  { name: "Square", imgSrc: "images/square.png" },
  { name: "People.ai", imgSrc: "images/people.png" },
  { name: "LiveChat", imgSrc: "images/live.png" },
  { name: "Sketch", imgSrc: "images/sketch.png" },
  { name: "Mapbox", imgSrc: "images/mapbox.png" },
];

const LogoCapsuleSection = () => {
  return (
    <section className="text-center max-w-5xl mx-auto pb-20">
      <div className="flex flex-wrap justify-center gap-10">
        {logos.map((logo, index) => (
          <div
            key={index}
            className="bg-white shadow py-2 px-5 rounded-full transform hover:scale-105 transition-transform duration-300 ease-in-out"
          >
            <img src={logo.imgSrc} alt={logo.name} className="w-30 h-10" />
        
          </div>
        ))}
      </div>
    </section>
  );
};

export default LogoCapsuleSection;
